import * as React from 'react';
import { ExpenseService } from '../../service/ExpenseService';
import { notification, Button, Popconfirm } from 'antd';
import { ExpenseEntryDetailInput } from './constants';
import { expenseEntryObject, ExpenseEntryFormData } from './constants';
import { ExpenseEntryForm } from './ExpenseEntryForm';
import { ExpenseNode } from '../../schema';
import { CompanyNodeEdge, Bussiness } from '../master/Company/constants';

export class AddExpenseEntry extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      expenseEntry: JSON.parse(JSON.stringify(expenseEntryObject)),
      buttonDisabled: false,
      expenseObjList: [],
    };
  }

  expenseService = new ExpenseService();

  onChange = (
    e:
      | React.ChangeEvent<HTMLInputElement>
      | { target: { name: string; value: string | number | boolean | null } },
  ) => {
    const expenseEntry = { ...this.state.expenseEntry };
    expenseEntry[e.target.name] = e.target.value;
    this.setState({ expenseEntry });
  };

  expenseChangeHandler = (
    e:
      | React.ChangeEvent<HTMLInputElement>
      | { target: { name: string; value: string | number } },
    index: number,
  ) => {
    const nextState: State = {
      ...this.state,
    };
    nextState.expenseEntry.expenseDetails[index][e.target.name] =
      e.target.value;
    this.setState(nextState);
  };

  updateExpenseRows = (type: string, index: number) => {
    const nextState: State = { ...this.state };
    if (type === '+') {
      nextState.expenseEntry.expenseDetails.push({
        date: null,
        expenseId: '',
        amount: 0,
        remarks: '',
        companyId: null,
      });
    } else {
      nextState.expenseEntry.expenseDetails.splice(index, 1);
    }
    this.setState(nextState);
  };

  expenseObjChangehandler = (expenseObj: ExpenseNode, index: number) => {
    const nextState = { ...this.state };
    nextState.expenseObjList[index] = expenseObj;
    nextState.expenseEntry.expenseDetails[index].expenseId =
      expenseObj.id || '';
    this.setState(nextState);
  };

  saveExpenseEntry = () => {
    this.setState({ buttonDisabled: true });
    const expenseEntry = { ...this.state.expenseEntry };
    expenseEntry.companyId = this.props.company.id;
    expenseEntry.branchId =
      this.props.business.type === 'branch' ? this.props.business.id : '';
    this.expenseService?.addExpenseEntry(
      expenseEntry,
      (response) => {
        this.setState({
          expenseEntry: JSON.parse(JSON.stringify(expenseEntryObject)),
        });
        this.setState({ buttonDisabled: false });
        notification.success({
          message: 'Updated',
          description: `Expense Entry was successfully Updated`,
        });
      },
      (error) =>
        notification.error({
          message: 'Expense Entry Update Error',
          description: JSON.stringify(error),
        }),
    );
  };

  clear = () => {
    this.setState({
      expenseEntry: JSON.parse(JSON.stringify(expenseEntryObject)),
    });
  };

  render() {
    return (
      <div>
        <ExpenseEntryForm
          value={this.state.expenseEntry}
          onChange={this.onChange}
          expenseChangeHandler={this.expenseChangeHandler}
          updateExpenseRows={this.updateExpenseRows}
          company={this.props.company}
          currentBusiness={this.props.business}
          expenseObjChangeHandler={this.expenseObjChangehandler}
          expenseObjList={this.state.expenseObjList}
        />
        <Popconfirm
          title="Are you sure to clear?"
          onConfirm={this.clear}
          okText="Yes"
          cancelText="No"
        >
          <Button type="dashed" children="Clear" style={{ width: '50%' }} />
        </Popconfirm>
        <Button
          type="primary"
          onClick={this.saveExpenseEntry}
          children="Submit"
          style={{ width: '50%' }}
          disabled={this.state.buttonDisabled}
        />
      </div>
    );
  }
}

interface Props {
  company: CompanyNodeEdge;
  business: Bussiness;
}

interface State {
  expenseEntry: ExpenseEntryFormData<ExpenseEntryDetailInput[]>;
  buttonDisabled: boolean;
  expenseObjList: ExpenseNode[];
}
